import styled from "styled-components";
import { ReactComponent as ChevronIcon } from "../../../assets/icons/chevron.svg";
import { colors } from "../../../theme";

export enum ChevronDirections {
  "NORTH" = "NORTH",
  "SOUTH" = "SOUTH",
  "EAST" = "EAST",
  "WEST" = "WEST",
}

const directionValues = {
  [ChevronDirections.NORTH]: "-90deg",
  [ChevronDirections.SOUTH]: "90deg",
  [ChevronDirections.EAST]: "0deg",
  [ChevronDirections.WEST]: "180deg",
};

interface IChevronProps {
  color?: string;
  direction?: ChevronDirections;
}

const Chevron = styled(ChevronIcon).withConfig({
  displayName: "Chevron",
})`
  color: ${({ color }: IChevronProps) => color || colors.white};
  transform: rotate(
    ${({ direction }: IChevronProps) =>
      directionValues[direction || ChevronDirections.NORTH]}
  );
`;

export default Chevron;
